import React from 'react';
import styles from './index.module.scss';

export interface HighlightCardProps {
  title: string;
  lead: string;
  detail?: string;
  image?: string;
}

export default function HighlightCard({ title, lead, detail, image }: HighlightCardProps) {
  return (
    <article className={styles.card}>
      {image ? (
        <img className={styles.decor} src={image} alt="" loading="lazy" />
      ) : null}
      <div className={styles.copy}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.textGroup}>
          <p className={styles.lead}>{lead}</p>
          {detail ? <p className={styles.detail}>{detail}</p> : null}
        </div>
      </div>
    </article>
  );
}
